module.exports = __webpack_public_path__ + "static/media/icon-light.e6c395af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/appshell/header/icon-light.svg
// module id = 984
// module chunks = 0